import { api, useApi } from '../api/queries'
import type { BanReplay } from '../api/types'
import { UniverseConstructorPage, UniverseDriverPage } from './PeoplePages'
import { UniverseRacePage } from './RacePage'
import {
  ReplayChampionshipPage,
  ReplayConstructorsPage,
  ReplayDriversPage,
  ReplaySeasonPage,
  universeOf,
  type Source,
} from './ReplayPages'

/** The server's one-word table: each season's own points, awarded by qualifying. */
const SCALE = 'qualifying'

const QUALIFYING: Source = {
  path: '/qualifying',
  suffix: 'on qualifying',
  use: function useQualifyingSource() {
    const replay = useApi<BanReplay>(['scale', SCALE], () =>
      api.GET('/api/v1/scale', { params: { query: { scale: SCALE } } }),
    )
    return {
      chosen: true,
      search: '',
      replay,
      summary: (
        <p className="prose muted">
          Only qualifying scores, on each season’s own points table and rules: pole is the win,
          second on the grid takes second place’s points, and so on.
        </p>
      ),
      seasonQuery: () => ({ scale: SCALE }),
      driverSeasons: (slug) => [
        ['scale', 'driver-seasons', slug, SCALE],
        () =>
          api.GET('/api/v1/scale/drivers/{slug}/seasons', {
            params: { path: { slug }, query: { scale: SCALE } },
          }),
      ],
    }
  },
}

export const QualifyingChampionshipPage = () => <ReplayChampionshipPage source={QUALIFYING} />
export const QualifyingDriversPage = () => <ReplayDriversPage source={QUALIFYING} />
export const QualifyingConstructorsPage = () => <ReplayConstructorsPage source={QUALIFYING} />
export const QualifyingSeasonPage = () => <ReplaySeasonPage source={QUALIFYING} />

const UNIVERSE = universeOf(QUALIFYING)
export const QualifyingDriverPage = () => <UniverseDriverPage universe={UNIVERSE} />
export const QualifyingConstructorPage = () => <UniverseConstructorPage universe={UNIVERSE} />
export const QualifyingRacePage = () => <UniverseRacePage universe={UNIVERSE} />
